import { ITEM_SET_QUESTION_SIZE } from '@exam-management/common/utils';
import { Flex, FormRadioSelection, Text } from '@shared/components';
import { useMemo } from 'react';

const MIN_ITEM_SET_QUESTION_SIZE = ITEM_SET_QUESTION_SIZE.MIN;
const MAX_ITEM_SET_QUESTION_SIZE = ITEM_SET_QUESTION_SIZE.MAX;

export interface ItemSetTypeSelectionProps {
  itemSetType?: number;
  isEditModal?: boolean;
}

export default function ItemSetTypeSelection(props: Readonly<ItemSetTypeSelectionProps>) {
  const { itemSetType, isEditModal } = props;

  const itemSetTypeOptions = useMemo(() => {
    return Array.from({
      length: MAX_ITEM_SET_QUESTION_SIZE - MIN_ITEM_SET_QUESTION_SIZE + 1,
    }).map((_, index) => {
      const value = index + MIN_ITEM_SET_QUESTION_SIZE;
      const isDisabled = isEditModal && itemSetType !== value;

      return {
        label: `${value}Q`,
        value,
        disabled: isDisabled,
      };
    });
  }, [isEditModal, itemSetType]);

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        backgroundColor: theme.palette.grey[50],
        borderRadius: theme.shape.rounded(2),
        border: `1px solid ${theme.palette.grey[200]}`,
        p: theme.spacing(4),
        gap: theme.spacing(1),
      })}
    >
      <Text variant='body2Semibold'>Item Set Type</Text>
      <FormRadioSelection name='itemSetType' options={itemSetTypeOptions} row />
    </Flex>
  );
}
